import { useEffect } from "react";

const setTag = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, image, schema }) => {
  useEffect(() => {
    const full = `${title} — Glam Wagon`;
    document.title = full;
    setTag("name", "description", description);
    setTag("property", "og:title", full);
    setTag("property", "og:description", description);
    setTag("property", "og:type", "website");
    if (image) setTag("property", "og:image", image);
    setTag("name", "twitter:card", "summary_large_image");
    setTag("name", "twitter:title", full);
    setTag("name", "twitter:description", description);
    if (image) setTag("name", "twitter:image", image);

    let ld = document.getElementById("ld-json");
    if (ld) ld.remove();
    if (schema) {
      ld = document.createElement("script");
      ld.id = "ld-json";
      ld.type = "application/ld+json";
      ld.text = JSON.stringify(schema);
      document.head.appendChild(ld);
    }
  }, [title, description, image, schema]);
  return null;
};
